import { render, staticRenderFns } from "./searchacademy.vue?vue&type=template&id=1d4ea826&scoped=true"
import script from "./searchacademy.vue?vue&type=script&lang=js"
export * from "./searchacademy.vue?vue&type=script&lang=js"
import style0 from "./searchacademy.vue?vue&type=style&index=0&id=1d4ea826&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ea826",
  null
  
)

export default component.exports